module.exports = __webpack_public_path__ + "img/diyCardTitle.e828339d.png";